

export class VehicleDetailsStatusInput implements IVehicleDetailsStatusInput {
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IVehicleDetailsStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.vehicleDetailsId = _data["vehicleDetailsId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): VehicleDetailsStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new VehicleDetailsStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["vehicleDetailsId"] = this.vehicleDetailsId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IVehicleDetailsStatusInput {
    /** The auto-generated id of the vehicle details master */
    vehicleDetailsId: number;
    /** The updated status */
    status: number;
}

